var apiService = function ($log, modelFactoryService, $q) {
    var catalogUrl = this.catalogUrl,
        useHttpBackendMock = this.useHttpBackendMock;
    var initDefer = $q.defer();
    var ApiService = {
        init: function () {
            initDefer.resolve(this);
        },
        onInit: function() {
            return initDefer.promise;
        },
        getCatalog: function () {
            if (!catalogUrl) {
                throw new Error('Catalog url was not set');
            }
            return modelFactoryService.getModel(catalogUrl, 'GET');
        }
    }
    return ApiService;
};

apiService.$inject = ['$log', 'modelFactoryService', '$q'];

var apiServiceProvider = function () {
    this.useHttpBackendMock = false;
    this.catalogUrl = '';
    this.useHttpBackendMock = function (value) {
        this.useHttpBackendMock = !!value;
    };
    this.setCatalogUrl = function (url) {
        this.catalogUrl = url;
    };
    this.$get = apiService;
};

module.exports = apiServiceProvider;
